export default __webpack_public_path__ + "static/media/rhodeisland.ae84a026.jpg";